'use strict';

var React = require('react');

var SvgStatusIcon = function SvgStatusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 4.55a5.501 5.501 0 1 0 6.25 5.45.75.75 0 0 1 1.5 0 7 7 0 1 1-7-7 .75.75 0 0 1 .75.75v4.95a1.5 1.5 0 1 1-1.5 0v-1.346a2.751 2.751 0 1 0 3.5 2.646.75.75 0 0 1 1.5 0 4.25 4.25 0 1 1-5-4.184v-1.265Z"
  }));
};
SvgStatusIcon.displayName = "StatusIcon";

exports.SvgStatusIcon = SvgStatusIcon;
